module.exports = __webpack_public_path__ + "static/canvas-days-6a41550d6d9fc3ed9c860ac3ca20141a.png";